.typography {
  margin: 0;
  font-family: var(--tuna-typography-fontFamily);
  color: inherit;
}

.body1 {
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: var(--tuna-typography-body1-fontWeight);
  line-height: var(--tuna-typography-body1-lineHeight);
  letter-spacing: var(--tuna-typography-body1-letterSpacing);
}

.body2 {
  font-size: var(--tuna-typography-body2-fontSize);
  font-weight: var(--tuna-typography-body2-fontWeight);
  line-height: var(--tuna-typography-body2-lineHeight);
  letter-spacing: var(--tuna-typography-body2-letterSpacing);
}

.caption {
  font-size: var(--tuna-typography-caption-fontSize);
  font-weight: var(--tuna-typography-caption-fontWeight);
  line-height: var(--tuna-typography-caption-lineHeight);
  letter-spacing: var(--tuna-typography-caption-letterSpacing);
}

.overline {
  font-size: var(--tuna-typography-overline-fontSize);
  font-weight: var(--tuna-typography-overline-fontWeight);
  line-height: var(--tuna-typography-overline-lineHeight);
  letter-spacing: var(--tuna-typography-overline-letterSpacing);
  text-transform: uppercase;
}

.subtitle1 {
  font-size: var(--tuna-typography-subtitle1-fontSize);
  font-weight: var(--tuna-typography-subtitle1-fontWeight);
  line-height: var(--tuna-typography-subtitle1-lineHeight);
}

.subtitle2 {
  font-size: var(--tuna-typography-subtitle2-fontSize);
  font-weight: var(--tuna-typography-subtitle2-fontWeight);
  line-height: var(--tuna-typography-subtitle2-lineHeight);
}

/* Heading sizes match the project's MUI theme (responsive) */
.h1 {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.167;
  margin-top: 16px;
  margin-bottom: 8px;
}
.h2 {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  margin-top: 16px;
  margin-bottom: 8px;
}
.h3 {
  font-size: 20px;
  font-weight: 500;
  line-height: 1.167;
  margin-top: 16px;
  margin-bottom: 8px;
}
.h4 {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.235;
  margin-top: 16px;
  margin-bottom: 8px;
}
.h5 {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.334;
  margin-top: 16px;
  margin-bottom: 8px;
}
.h6 {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.6;
  margin-top: 8px;
  margin-bottom: 8px;
}

/* md breakpoint (900px+) */
@media (min-width: 900px) {
  .h1 {
    font-size: 36px;
  }
  .h2 {
    font-size: 28px;
  }
  .h3 {
    font-size: 22px;
  }
  .h4 {
    font-size: 20px;
  }
  .h5 {
    font-size: 20px;
  }
  .h6 {
    font-size: 18px;
  }
}

/* lg breakpoint (1200px+) */
@media (min-width: 1200px) {
  .h1 {
    font-size: 40px;
  }
  .h2 {
    font-size: 30px;
  }
  .h3 {
    font-size: 24px;
  }
  .h4 {
    font-size: 24px;
  }
  .h5 {
    font-size: 22px;
  }
  .h6 {
    font-size: 20px;
  }
}

.button {
  font-size: var(--tuna-typography-button-fontSize);
  font-weight: var(--tuna-typography-button-fontWeight);
  line-height: var(--tuna-typography-button-lineHeight);
  letter-spacing: var(--tuna-typography-button-letterSpacing);
  text-transform: uppercase;
}

.colorPrimary {
  color: var(--tuna-palette-primary-main);
}

.colorSecondary {
  color: var(--tuna-palette-secondary-main);
}

.colorError {
  color: var(--tuna-palette-error-main);
}

.colorSuccess {
  color: var(--tuna-palette-success-main);
}

.colorTextSecondary {
  color: var(--tuna-palette-text-secondary);
}

.colorTextDisabled {
  color: var(--tuna-palette-text-disabled);
}

.noWrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gutterBottom {
  margin-bottom: 0.35em;
}

.alignCenter {
  text-align: center;
}

.alignRight {
  text-align: right;
}

.alignJustify {
  text-align: justify;
}
